module.exports = __webpack_public_path__ + "img/account-default-cover.e43133a9.png";